import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowRightRound = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.293 7.707a1 1 0 1 1 1.415-1.414l5 5.006a1 1 0 0 1-.001 1.414l-5 4.995a1 1 0 1 1-1.414-1.415L15.59 13H5.211a1 1 0 1 1 0-2h10.371l-3.29-3.293Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowRightRound);
export default Memo;
